module.exports = __webpack_public_path__ + "static/media/ic-creative.b6a083dc.svg";